<template lang="pug">
GenericCard.root(size='auto')
  button.transparent-button.no-scaling.stat-item.d-flex.align-items-center.w-100.p-3(
    :class='highlighted ? `highlighted`:``'
    @click='$emit(`click`)'
  )
    //- .amount.rounded-circle {{ badgeNumber }}

    .d-flex.flex-column.align-items-end.ml-auto
      .key {{ title }}
      //- .value {{ value | currency }}
      .value {{ badgeNumber.toLocaleString() }} รายการ
</template>

<script>
export default {
  props: {
    badgeNumber: {
      default: -1,
    },
    title: {
      default: '...',
    },
    value: {
      default: -1,
    },

    highlighted: {
      default: false,
    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 1024px) {
  .root {
    min-width: 50%;
  }
}

.stat-item {
  border-radius: $card-border-radius;

  .amount {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    width: 64px;
    background: #0092C9;

    font-size: 32px;
    color: #fff;
  }
  .key {
    font-size: 14px;
    color: #6B6C6F;

    letter-spacing: 1px;
  }
  .value {
    color: #303030;
    font-size: 28px;

    margin-top: -6px;
    letter-spacing: 1px;
    font-weight: 500;
  }

  &.highlighted {
    background: linear-gradient(to right, #0B478B, #1C87AE);

    .amount {
      background: #fff;
      color: #134D8B;
    }
    .key {
      color: #fff;
      font-weight: 300;
    }
    .value {
      color: #fff;
      font-weight: 300;
    }
  }
}
</style>
